package com.eladfinish.bible.contest.common.usecases

import com.eladfinish.bible.contest.constants.StringConstants.MAKAF
import com.eladfinish.bible.contest.constants.StringConstants.Regex.NIKUD_CHARS
import com.eladfinish.bible.contest.extensions.replaceRegex

class RemoveNikudAndMakafUseCase {

    operator fun invoke(pasuk: String): String =
        pasuk
            .replaceRegex(
                regex = NIKUD_CHARS,
                replacement = ""
            )
            .replaceRegex(
                regex = MAKAF.toString(),
                replacement = " "
            )
            .trim()

}
